'use strict';

exports.__esModule = true;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _animateScroll = require('./animateScroll');
var _animateScroll2 = _interopRequireDefault(_animateScroll);
var _scrollEvents = require('./scrollEvents');
var _scrollEvents2 = _interopRequireDefault(_scrollEvents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var __mapped = {};
var __activeLink = void 0;
exports.default = {
  unmount: function unmount() {
    __mapped = {};
  },
  register: function register(name, element) {
    __mapped[name] = element;
  },
  unregister: function unregister(name) {
    delete __mapped[name];
  },
  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByClassName(name)[0];
  },
  setActiveLink: function setActiveLink(link) {
    __activeLink = link;
  },
  getActiveLink: function getActiveLink() {
    return __activeLink;
  },
  scrollTo: function scrollTo(to) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    /*
    * get the mapped DOM element
    */

    var target = this.get(to);
    if (!target) {
      console.warn('target Element not found');
      return;
    }
    var props = (0, _extends3.default)({}, options, {
      absolute: false
    });
    if (_scrollEvents2.default.registered.begin) {
      _scrollEvents2.default.registered.begin(to, target);
    }
    var containerId = props.containerId;
    var containerElement = containerId ? document.getElementById(containerId) : null;
    var scrollOffset = void 0;
    if (containerId && containerElement) {
      props.absolute = true;
      if (containerElement !== target.offsetParent) {
        if (!containerElement.contains(target)) {
          throw new Error('Container with ID ' + containerId + ' is not a parent of target ' + to);
        } else {
          throw new Error('Container with ID ' + containerId + ' is not a positioned element');
        }
      }
      scrollOffset = target.offsetTop;
    } else {
      var coordinates = target.getBoundingClientRect();
      scrollOffset = coordinates.top;
    }
    scrollOffset += props.offset || 0;

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (containerId && containerElement) {
        containerElement.scrollTop = scrollOffset;
      } else {
        // window.scrollTo accepts only absolute values so body rectangle needs to be subtracted
        var bodyRect = document.body.getBoundingClientRect();
        window.scrollTo(0, scrollOffset - bodyRect.top);
      }
      if (_scrollEvents2.default.registered.end) {
        _scrollEvents2.default.registered.end(to, target);
      }
      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};
module.exports = exports['default'];